// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PMSEligibilityList__wrapper___2Pa3Q","type":"PMSEligibilityList__type___2upsj"};